﻿
export const ProductConstants = {
    FormConstants: {
        Neat: "N",
        MixedSolution: "MSN",
        MixedSolid: "MSD",
    },
    ShippingConditionConstants: {
        Ambient: "AMB",
        WetIce: "WET",
        DryIce: "DRY",
    }
}
